import { useSnapshot } from 'valtio'
import * as React from 'react'
import { mapState } from '../../../store/mapState.ts'
import { clearRoute, doRoute } from './directionHelper.tsx'

export const MobileDirections: React.FC = () => {
    const map = (useSnapshot(mapState) as typeof mapState).map
    const myPosition = (useSnapshot(mapState) as typeof mapState).myPosition
    const directionsTo: google.maps.LatLng | null = (useSnapshot(mapState) as typeof mapState).directionsTo
    const travelMode = (useSnapshot(mapState) as typeof mapState).travelMode

    React.useEffect(() => {
        return () => {
            setTimeout(() => clearRoute())
        }
    }, [])

    React.useEffect(() => {
        if (myPosition && directionsTo) {
            void doRoute(map, travelMode, myPosition, directionsTo)
        }
    }, [myPosition, directionsTo])

    return null
}